"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = __importDefault(require("./Field"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var Context_1 = require("../Context");
var utils_1 = require("../utils");
var useBoolValueValidation_1 = __importDefault(require("./hooks/useBoolValueValidation"));
function CheckBoxField(props, ref) {
    var 
    /* field props start*/
    label = props.label, name = props.name, required = props.required, validate = props.validate, disableLabelBox = props.disableLabelBox, fieldBasis = props.fieldBasis, bottomContent = props.bottomContent, 
    /* field props end */
    /* local props start */
    onChange = props.onChange, 
    /* local props end */
    checkBoxProps = __rest(props, ["label", "name", "required", "validate", "disableLabelBox", "fieldBasis", "bottomContent", "onChange"]);
    var fieldProps = {
        label: label,
        name: name,
        required: required,
        validate: validate,
        disableLabelBox: disableLabelBox,
        fieldBasis: fieldBasis,
        bottomContent: bottomContent
    };
    (0, useBoolValueValidation_1.default)(name);
    var formContext = (0, Context_1.useFormContext)();
    var formId = formContext.formId, values = formContext.values, isSubmitting = formContext.isSubmitting, handleFormikChange = formContext.handleChange, handleBlur = formContext.handleBlur;
    var handleChange = function (event) {
        handleFormikChange(event);
        // custom onChange
        onChange === null || onChange === void 0 ? void 0 : onChange(event, formContext);
    };
    return (react_1.default.createElement(Field_1.default, __assign({}, fieldProps, { disableLabelBox // disable labelBox, check box already has its own label
        : true }),
        react_1.default.createElement(Checkbox_1.default, __assign({}, checkBoxProps, { id: (0, utils_1.getIdName)(formId, name), ref: ref, name: name, checked: values[name], onChange: handleChange, onBlur: handleBlur, label: label, disabled: isSubmitting || checkBoxProps.disabled }))));
}
exports.default = react_1.default.forwardRef(CheckBoxField);
